import { Body, Box, Help, useTooltipSeries } from '../widgets'

export const ResetTooltips = ({ guide }) => {
  const { reset } = useTooltipSeries()

  return (
    <Box
      position="fixed"
      bottom={40}
      left={80}
      className="desktop-only"
      alignItems="center"
      gap={8}
      cursor="pointer"
      onClick={() => reset(guide)}
      zIndex={2000}
    >
      <Help />
      <Body alt bold underline italic>Help</Body>
    </Box>
  )
}